import { useState, useEffect } from "react";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Hero } from "./components/Hero";
import { EventsSection } from "./components/EventsSection";
import { LiveScores } from "./components/LiveScores";
import { Gallery } from "./components/Gallery";
import { AdminLogin } from "./components/AdminLogin";
import { AdminDashboard } from "./components/AdminDashboard";
import { Shield } from "lucide-react";

function AppContent() {
  const [isAdminRoute, setIsAdminRoute] = useState(false);
  const { user, loading } = useAuth();

  useEffect(() => {
    const checkRoute = () => {
      const path = window.location.pathname;
      setIsAdminRoute(path.startsWith("/admin"));
    };

    checkRoute();

    window.addEventListener("popstate", checkRoute);
    return () => window.removeEventListener("popstate", checkRoute);
  }, []);

  const handleAdminClick = () => {
    window.history.pushState({}, "", "/admin");
    setIsAdminRoute(true);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAdminRoute) {
    return user ? <AdminDashboard /> : <AdminLogin />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <EventsSection />
      <LiveScores />
      <Gallery />

      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-2">
            Sydney International School of Technology and Commerce
          </h3>
          <p className="text-gray-400 mb-8">Nova Fest 2026</p>

          <button
            onClick={handleAdminClick}
            className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-6 py-3 rounded-lg transition-colors font-medium mx-auto"
          >
            <Shield className="w-5 h-5" />
            Admin Panel
          </button>

          <div className="mt-8 text-gray-500 text-sm">
            <p>&copy; 2026 SISTC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;